import { render, staticRenderFns } from "./xianfengsgCode.vue?vue&type=template&id=57e4854f&scoped=true&"
import script from "./xianfengsgCode.vue?vue&type=script&lang=js&"
export * from "./xianfengsgCode.vue?vue&type=script&lang=js&"
import style0 from "./xianfengsgCode.vue?vue&type=style&index=0&id=57e4854f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e4854f",
  null
  
)

export default component.exports